// Map the submitted legacy values to the shared analytics bucket contract.
// A bucket is not an exact headcount; the open-ended bucket has no upper bound.
export const employeeCountOptions = [
  {
    value: '1-10',
    employee_count_bucket: '1–10 employees',
    employee_count_min: 1,
    employee_count_max: 10,
  },
  {
    value: '11-50',
    employee_count_bucket: '11–50 employees',
    employee_count_min: 11,
    employee_count_max: 50,
  },
  {
    value: '51-100',
    employee_count_bucket: '51–100 employees',
    employee_count_min: 51,
    employee_count_max: 100,
  },
  {
    value: '101-250',
    employee_count_bucket: '101–250 employees',
    employee_count_min: 101,
    employee_count_max: 250,
  },
  {
    value: '251+',
    employee_count_bucket: '251+ employees',
    employee_count_min: 251,
    employee_count_max: null,
  },
] as const
